import React, { useState } from "react";
import styled from "styled-components";
import ProgressButton from "../utils/ProgressButton";
import { getWorstLacProgress } from "../utils/CounterFormat";


const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 0.8rem;
`;

function LacButtons({lacItems, locations, onSelect}) {
  const [selectedId, setSelectedId] = useState(null);

const generateRandomNumber = () => Math.floor(Math.random() * 100) + 1;

  const handleButtonClick = (id) => {
    setSelectedId(id);
    onSelect?.(id);
  };

  return (
    <Grid>
      {lacItems.map((lac) => (
        <ProgressButton
          key={lac}
          id={lac}
          label={"LAC " + lac}
          progress={getWorstLacProgress(locations, lac) ?? 0}
          isActive={lac === selectedId}
          onClick={handleButtonClick}
        />
      ))}
    </Grid>
  );
}

export default LacButtons;